import { createBrowserRouter } from 'react-router-dom'
import Interface from './interface'
import Usuario from './programas/usuario'
import ProgramaControle from './programas/administracao/programa'
import PerfilPermissao from './programas/administracao/perfilPermissao'
import TipoUsuario from './programas/administracao/tipoUsuario'
import Contratante from './programas/administracao/contratante'
import Login from './interface/login/'
import { Dashboard } from './programas/dashboard'
import TipoUsuarioSistema from './programas/administracao/tipoUsuarioSistema'
import Pais from './programas/cadastro/pais'
import Cidade from './programas/cadastro/cidade'
import Estado from './programas/cadastro/estado'
import Empresa from './programas/cadastro/empresa'
import Cliente from './programas/cadastro/cliente'
import Denuncia from './programas/denuncia/'
import Categoria from './programas/categoria/'
import Notificacao from './programas/notificacao'
import Profiles from './programas/profiles';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Interface />,
  },
  {
    path: '/programas',
    element: <Interface />,
    children: [
      { path: '/programas/dashboard', element: <Dashboard /> },
      { path: '/programas/usuario', element: <Usuario /> },
      {
        path: '/programas/administracao/programa',
        element: <ProgramaControle />,
      },
      {
        path: '/programas/administracao/perfilPermissao',
        element: <PerfilPermissao />,
      },
      {
        path: '/programas/administracao/tipoUsuario',
        element: <TipoUsuario />,
      },
      {
        path: '/programas/administracao/tipoUsuarioSistema',
        element: <TipoUsuarioSistema />,
      },
      {
        path: '/programas/administracao/contratante',
        element: <Contratante />,
      },
      {
        path: '/programas/cadastro/cliente',
        element: <Cliente />,
      },
      {
        path: '/programas/cadastro/pais',
        element: <Pais />,
      },
      {
        path: '/programas/cadastro/cidade',
        element: <Cidade />,
      },
      {
        path: '/programas/cadastro/estado',
        element: <Estado />,
      },
      {
        path: '/programas/cadastro/empresa',
        element: <Empresa />,
      },
      {
        path: '/programas/denuncia/denuncia',
        element: <Denuncia />,
      },
      {
        path: '/programas/categoria/categoria',
        element: <Categoria />,
      },
      {
        path: '/programas/notificacao/usuario',
        element: <Notificacao />,
      },
      {
        path: '/programas/cadastro/perfis',
        element: <Profiles />,
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
])
